import { render, staticRenderFns } from "./DocumentEditorPage.vue?vue&type=template&id=6008a658"
import script from "./DocumentEditorPage.vue?vue&type=script&lang=ts"
export * from "./DocumentEditorPage.vue?vue&type=script&lang=ts"
import style0 from "./DocumentEditorPage.vue?vue&type=style&index=0&id=6008a658&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports